import { FINRA_LINK, SIPC_LINK } from 'constants/link.constants'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSLink from 'designSystem/components/PDSLink/PDSLink'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

export default function PaveSecuritiesFooter() {
  return (
    <PDSFlexBox alignItems="center" justifyContent="center" padding={SIZE.s36}>
      <PDSText color={COLOR.textSecondary}>
        Pave Securities, LLC Is a member of{' '}
        <PDSLink
          rel="noopener noreferrer"
          target="_blank"
          to={FINRA_LINK}
          text="FINRA"
          variant="secondary"
        />{' '}
        and{' '}
        <PDSLink
          rel="noopener noreferrer"
          target="_blank"
          to={SIPC_LINK}
          text="SIPC"
          variant="secondary"
        />{' '}
        regulated by the US Securities and Exchange Commission
      </PDSText>
    </PDSFlexBox>
  )
}
